import "./sentry";  // first: catch errors from everything below
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { Sentry } from "./sentry";

// After a redeploy, an open tab may ask for an old code chunk that no longer exists (the server answers with the
// HTML page → "Unexpected token '<'" / ChunkLoadError). Reload once to pick up the new version; at most once a minute.
const STALE = /ChunkLoadError|Loading (CSS )?chunk|Unexpected token '<'|dynamically imported module|Importing a module script failed/i;
const reloadOnce = (msg) => {
  if (!STALE.test(msg || "")) return false;
  try {
    const last = Number(sessionStorage.getItem("buma_stale_reload") || 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem("buma_stale_reload", String(Date.now()));
  } catch { return false; }
  window.location.reload();
  return true;
};
window.addEventListener("error", (e) => { reloadOnce(e?.message); });
window.addEventListener("unhandledrejection", (e) => { reloadOnce(e?.reason?.message || String(e?.reason || "")); });

const Crash = ({ error }) => {
  React.useEffect(() => { reloadOnce(`${error?.name || ""} ${error?.message || ""}`); }, [error]);
  return (
  <div style={{ padding: 32, fontFamily: "sans-serif" }} data-testid="app-crash">
    <h1 style={{ fontSize: 20, fontWeight: 700 }}>Something went wrong · حدث خطأ ما</h1>
    <button type="button" onClick={() => window.location.reload()} style={{ marginTop: 12, padding: "8px 16px", borderRadius: 999, background: "#0038EB", color: "#fff" }}>Reload · إعادة التحميل</button>
  </div>
  );
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ error }) => <Crash error={error} />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
